<template>
  <div class="switch-input-container">
    <label class="switch">
      <input
        type="checkbox"
        class="switch-input"
        @change="() => $emit('change')"
      />
      <span class="switch-label" data-on="On" data-off="Off"></span>
      <span class="switch-handle"></span>
    </label>
    {{ label }}
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'SwitchInput',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    onChange: {
      type: Function,
      default: event => event
    }
  }
})
</script>

<style lang="scss" scoped>
.switch-input-container {
  display: flex;
  gap: 7px;
}
.switch {
  position: relative;

  display: inline-block;
  width: 45px;
  height: 22px;
  padding: 3px;

  vertical-align: top;

  border-radius: 12px;
  cursor: pointer;
}
.switch-input {
  position: absolute;
  top: 0;
  left: 0;

  opacity: 0;
}
.switch-label {
  position: relative;

  display: block;
  height: inherit;

  font-size: 10px;
  text-transform: uppercase;

  background: #eceeef none repeat scroll 0 0;
  border-radius: inherit;

  transition: all 0.15s ease-out 0s;
}
.switch-label::before,
.switch-label::after {
  position: absolute;
  top: 50%;

  margin-top: -0.5em;

  line-height: 1;

  transition: inherit;
}

.switch-input:checked ~ .switch-label {
  background: #00c16a none repeat scroll 0 0;
}

.switch-handle {
  position: absolute;
  top: 6px;
  left: 6px;

  width: 15px;
  height: 15px;

  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);

  transition: left 0.15s ease-out 0s;
}
.switch-handle::before {
  position: absolute;
  top: 50%;
  left: 50%;

  width: 12px;
  height: 12px;
  margin: -6px 0 0 -6px;

  border-radius: 6px;

  content: '';
}
.switch-input:checked ~ .switch-handle {
  left: 24px;
}
</style>
